import Button from '@mui/material/Button';
import React from 'react';
import { textToTextNumberModifier } from '../../helpers/text-to-number-modifier';
import CryptoIcon from '../CryptoIcon/CryptoIcon';
import "./AmountInput.scss";
import {baseAssetOverride} from "../trade-tabs/helpers/position-columns";

export interface AmountInputProps {
    label?: string;
    available?: number | string;
    asset?: string;
    hasMaxButton?: boolean;
    onChange?: (value: string) => void;
    value?: number | string;
    shouldAdjustToMaxAmount?: boolean;
    precision?: number;
    placeholder?: string;
}

const AmountInput: React.FC<AmountInputProps> = ({
                                                     label,
                                                     available,
                                                     asset,
                                                     hasMaxButton,
                                                     onChange,
                                                     value = 0,
                                                     precision = 6,
                                                     placeholder,
                                                     shouldAdjustToMaxAmount
                                                 }) => {

    const handleMaxClick = () => {
        if (available !== undefined) {
            const maxAmount = Number(available) || 0;
            if (onChange) {
                onChange(maxAmount + '');
            }
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let inputVal = event.target.value;

        inputVal = textToTextNumberModifier(inputVal, precision);

        // Call onChange if it's provided
        if (onChange) {
            onChange(inputVal);
        }
    };

    return (
        <div className="AmountInput">
            <div className="AmountInput__firstRow">
                <div>
                    <label className="AmountInput__label">{label}</label>
                </div>
                {(available !== undefined) && (<div>
                    <label className="AmountInput__available">Available: {available}</label>
                    {hasMaxButton && (<Button variant="outlined" className="AmountInput__maxButton"
                                              onClick={handleMaxClick}>MAX</Button>)}
                </div>)}
            </div>
            <div className="AmountInput__secondRow">
                <div>
                    <input disabled={!onChange} className="AmountInput__input" placeholder={placeholder ||''} type="string" value={value || ''}
                                         onChange={handleInputChange}/>
                </div>
                {asset && (<div className="AmountInput__assetInfo">
                    <CryptoIcon size={16} ticker={asset}/>
                    <span className="ml-1 uppercase">{baseAssetOverride(asset)}</span>
                </div>)}
            </div>

        </div>
    );
};

export default AmountInput;
